export default __webpack_public_path__ + "static/media/RequestInactive.d0a99250.svg";